export enum CallReason {
    General = 0,
    CancelledAppointment = 1,
    GeneralReview = 2,
    NoShow = 3,
}
